import React, { useState } from 'react';
import { Card, Button } from './ui';
import { ShieldCheck, Plus, Minus, Scale, Clock, Lock, Zap, CreditCard } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-268">
      <div className="max-w-3xl mx-auto" data-id="element-269">
        <Card className="bg-gradient-to-br from-slate-900 to-slate-800 border-emerald-500/30 text-center relative overflow-hidden" data-id="element-270">
          <div className="absolute -right-10 -top-10 text-emerald-500/10" data-id="element-271">
            <ShieldCheck className="w-64 h-64" data-id="element-272" />
          </div>
          <div className="relative z-10" data-id="element-273">
            <ShieldCheck className="w-16 h-16 text-emerald-400 mx-auto mb-6" data-id="element-274" />
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-275">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>
            <p className="text-xl text-slate-300 mb-6" data-id="element-276">
              Abrís los tomos. Los usás en tu cocina.
            </p>
            <p className="text-lg text-slate-400 mb-8" data-id="element-277">
              Si en 7 días no es lo que esperabas:
              <br data-id="element-278" />
              <strong className="text-white" data-id="element-279">devolución del 100%</strong>
              <br data-id="element-280" />
              sin formularios, sin drama.
            </p>
            <p className="text-sm text-emerald-400/80 font-medium" data-id="element-281">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si nunca hice batch cooking?',
    a: 'Sí. El Tomo 1 está diseñado exactamente para eso. Explica el sistema desde cero sin asumir ningún conocimiento previo. Cualquier persona con una cocina estándar puede implementarlo desde el primer domingo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital en PDF. Después de completar el pago recibís un email automático con el enlace de descarga en menos de 5 minutos. Podés verlo en el celular, la tablet o imprimirlo en casa.'
  }, {
    q: '¿Qué lo diferencia de buscar recetas en Google?',
    a: 'Google te da recetas sueltas. El Megapack te da un sistema completo donde cada receta está pensada para congelarse, regenerarse en minutos y formar parte de un ciclo semanal que funciona solo. No es lo mismo tener ingredientes sueltos que tener una cocina organizada.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días completos sin preguntas. Si no estás satisfecho por cualquier motivo escribís a supportpuntodigital@gmail.com y te devolvemos el 100% del pago. Sin formularios ni condiciones ocultas.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-slate-900/30 pt-[4px] pb-[4px]" data-id="element-282">
      <div className="max-w-3xl mx-auto" data-id="element-283">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center mb-8 flex items-center justify-center gap-3" data-id="element-284">
          <span className="text-brand-400" data-id="element-285">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-286">
          {faqs.map((faq, i) => <div key={i} className="border border-slate-800 rounded-xl bg-slate-900 overflow-hidden" data-id="element-287">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpen(open === i ? null : i)} data-id="element-288">
                <span className="font-bold text-white pr-8" data-id="element-289">{faq.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-brand-400 shrink-0" data-id="element-290" /> : <Plus className="w-5 h-5 text-slate-500 shrink-0" data-id="element-291" />}
              </button>
              {open === i && <div className="px-6 pb-4 text-slate-400" data-id="element-292">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}
export function CostOfInaction() {
  return <section className="py-12 px-4" data-id="element-293">
      <div className="max-w-4xl mx-auto" data-id="element-294">
        <div className="text-center mb-8" data-id="element-295">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-296">
            <Scale className="w-9 h-9 text-amber-400" data-id="element-297" /> ¿CUÁNTO CUESTA NO
            TENERLO?
          </h2>
        </div>

        <div className="overflow-x-auto mb-10" data-id="element-298">
          <table className="w-full text-left border-collapse bg-slate-900 rounded-xl overflow-hidden" data-id="element-299">
            <thead data-id="element-300">
              <tr className="border-b border-slate-800 bg-slate-800/50" data-id="element-301">
                <th className="p-4 text-slate-300 font-medium" data-id="element-302">Sin Megapack</th>
                <th className="p-4 text-red-400 font-bold" data-id="element-303">Costo real</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800" data-id="element-304">
              <tr data-id="element-305">
                <td className="p-4 text-slate-400" data-id="element-306">
                  Delivery 3 veces por semana × 52 semanas
                </td>
                <td className="p-4 text-white font-medium" data-id="element-307">
                  +$936.000 ARS al año
                </td>
              </tr>
              <tr data-id="element-308">
                <td className="p-4 text-slate-400" data-id="element-309">
                  20 min de angustia nocturna × 365 días
                </td>
                <td className="p-4 text-white font-medium" data-id="element-310">
                  121 horas de estrés por año
                </td>
              </tr>
              <tr data-id="element-311">
                <td className="p-4 text-slate-400" data-id="element-312">
                  Comida que se vence sin planificación
                </td>
                <td className="p-4 text-white font-medium" data-id="element-313">
                  $15.000-25.000 ARS mensuales tirados
                </td>
              </tr>
              <tr data-id="element-314">
                <td className="p-4 text-slate-400" data-id="element-315">
                  Domingo cocinando sin sistema ni resultados
                </td>
                <td className="p-4 text-white font-medium" data-id="element-316">
                  El mismo agotamiento el próximo lunes
                </td>
              </tr>
              <tr data-id="element-317">
                <td className="p-4 text-slate-400" data-id="element-318">
                  Luncheras armadas a las 7am en caos
                </td>
                <td className="p-4 text-white font-medium" data-id="element-319">
                  5 mañanas de stress por semana
                </td>
              </tr>
              <tr data-id="element-320">
                <td className="p-4 text-slate-400" data-id="element-321">
                  Freezer lleno de cosas sin etiqueta que no sabés qué son
                </td>
                <td className="p-4 text-white font-medium" data-id="element-322">
                  Decisión bloqueada cada noche
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-323">
          <h3 className="text-2xl font-bold text-brand-400 mb-4" data-id="element-324">
            El próximo lunes puede ser diferente.
          </h3>
          <blockquote className="text-xl text-slate-300 italic border-l-4 border-brand-500 pl-6 py-2 text-left" data-id="element-325">
            "La diferencia entre las familias que comen bien durante la semana y
            las que no, no es el dinero ni el tiempo. Es el sistema."
          </blockquote>
        </div>

        {/* Final CTA Block */}
        <Card glow className="bg-slate-900 border-brand-500/50 text-center" data-id="element-326">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 border border-red-500/20 px-4 py-2 rounded-full font-bold mb-8" data-id="element-327">
            <Clock className="w-5 h-5" data-id="element-328" />
            EL PRECIO CIERRA EN: 23 hs : 59 min : 52 seg
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-329">
            <div className="p-6 border border-slate-700 rounded-xl bg-slate-800/50" data-id="element-330">
              <h4 className="font-bold text-white mb-2" data-id="element-331">
                📘 MEGAPACK FREEZER LLENO
              </h4>
              <p className="text-sm text-slate-400 mb-4" data-id="element-332">
                6 Tomos + 6 Bonos · Todo el año resuelto
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-333">
                <span className="text-slate-500 line-through text-sm" data-id="element-334">
                  49990
                </span>
                <span className="text-3xl font-black text-white" data-id="element-335">$19.990</span>
                <span className="text-sm text-slate-400" data-id="element-336">ARS</span>
              </div>
              <Button className="w-full" variant="outline" data-id="element-337">
                → QUIERO MI MEGAPACK
              </Button>
            </div>

            <div className="p-6 border border-brand-500 rounded-xl bg-brand-900/10 relative" data-id="element-338">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-339">
                MÁS ELEGIDO
              </div>
              <h4 className="font-bold text-white mb-2" data-id="element-340">
                🏆 MEGAPACK + FREEZER PRO
              </h4>
              <p className="text-sm text-brand-400 mb-4" data-id="element-341">
                6 Tomos + 6 Bonos + Manual Avanzado
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-342">
                <span className="text-slate-500 line-through text-sm" data-id="element-343">
                  69990
                </span>
                <span className="text-3xl font-black text-white" data-id="element-344">$27.990</span>
                <span className="text-sm text-slate-400" data-id="element-345">ARS</span>
              </div>
              <Button className="w-full" data-id="element-346">→ QUIERO EL COMBO COMPLETO</Button>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400" data-id="element-347">
            <span className="flex items-center" data-id="element-348">
              <Lock className="w-4 h-4 mr-1 text-slate-300" data-id="element-349" /> Pago 100% seguro
            </span>
            <span className="flex items-center" data-id="element-350">
              <Zap className="w-4 h-4 mr-1 text-amber-400" data-id="element-351" /> Acceso en 5
              minutos
            </span>
            <span className="flex items-center" data-id="element-352">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-400" data-id="element-353" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-354">
              <CreditCard className="w-4 h-4 mr-1 text-blue-400" data-id="element-355" /> Mercado Pago
              | Tarjeta | Transferencia
            </span>
          </div>
        </Card>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-slate-950 py-10 px-4 border-t border-slate-900" data-id="element-356">
      <div className="max-w-4xl mx-auto text-center" data-id="element-357">
        <div className="inline-flex items-center gap-2 mb-6" data-id="element-358">
          <span className="text-2xl" data-id="element-359">🧊</span>
          <span className="text-brand-400 font-bold tracking-widest uppercase" data-id="element-360">
            PUNTO DIGITAL™
          </span>
        </div>

        <p className="text-slate-400 mb-4 max-w-2xl mx-auto" data-id="element-361">
          El sistema de alimentación N°1 para familias y trabajadores argentinos
          que quieren comer bien sin improvisar todas las noches.
        </p>
        <p className="text-slate-500 mb-8 italic" data-id="element-362">
          Porque resolver qué comer no debería costarte todos los domingos del
          año.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-slate-400 mb-12" data-id="element-363">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-brand-400 transition-colors" data-id="element-364">
            📧 supportpuntodigital@gmail.com
          </a>
          <a href="#" className="hover:text-brand-400 transition-colors" data-id="element-365">
            🌐 www.puntodigital.store
          </a>
        </div>

        <div className="text-xs text-slate-600 space-y-2" data-id="element-366">
          <p data-id="element-367">© Punto Digital™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-368">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-900" data-id="element-369">
          <p className="text-brand-500/50 font-medium italic" data-id="element-370">
            🧊 "El próximo lunes puede ser diferente."
          </p>
          <p className="text-slate-500 text-sm mt-2" data-id="element-371">
            "Un freezer lleno no es solo comida. Es tranquilidad."
          </p>
        </div>
      </div>
    </footer>;
}